import { amsManageGuard } from './ams-manage.guard';

// Mesma permissão de gestão AMS (canManageAms$) usada para proteger a área de clientes.
export const clientsGuard = amsManageGuard;
